var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"no-border-padding cards-container",attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('BCCSerial',{attrs:{"loading":_vm.dataLoaded,"versions":_vm.versions}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }